import React from "react";
import classes from './SliderDuration.module.sass'

function SliderDurationMedicair(props) {
  const {
    realDurationLabel,
    realDuration,
    estimateLabel,
    estimate,
    separator
  } = props

  return (
    <div className="row text-center border-start border-end">
      <div className="d-flex justify-content-center w-100">
        <div>
          <div className={classes.dataMedicair}>{(realDuration / 60).toFixed(0)}</div>
        </div>
        <div>
          <div>
            <div className={classes.label}>{realDurationLabel}</div>
            <div className="d-flex">
              <span className={`${classes.separator} me-1`}>{separator}</span>
              <div className={classes.data}>{(estimate / 60).toFixed(0)} min</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SliderDurationMedicair